import React from "react";
import { components } from "react-select";

const Option = props => {
  const { children = "" } = props;

  const childrenArray = children.split(" ");

  const newLabel = childrenArray.slice(0, childrenArray.length - 1).join(" ");

  return <components.Option {...props}>{newLabel}</components.Option>;
};

export default Option;
